import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, BadgeCheck, ShieldCheck, FileText } from "lucide-react";
import Logo from "../components/Logo";
import BottomNav from "../components/BottomNav";
import ThemeToggle from "../components/ThemeToggle";
import { clearSession, getSession, formatCpfCnpj } from "../lib/auth";
import TermsModal from "../components/TermsModal";

export default function Profile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    const s = getSession();
    if (!s) navigate("/", { replace: true });
    setUser(s);
  }, [navigate]);

  const logout = () => {
    clearSession();
    sessionStorage.removeItem("gp_loc");
    navigate("/", { replace: true });
  };

  return (
    <div className="app-shell pb-24" data-testid="profile-screen">
      <header className="sticky top-0 z-30 bg-white/90 dark:bg-slate-900/90 backdrop-blur-md border-b border-slate-100 dark:border-slate-800 px-4 py-3 flex items-center justify-between">
        <Logo size="sm" subtitle />
        <ThemeToggle />
      </header>

      <main className="px-5 pt-6 space-y-4">
        <h1 className="font-display text-2xl font-bold text-slate-900 dark:text-white">Perfil</h1>
        <div className="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl p-5 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="h-14 w-14 rounded-full bg-[#00D285]/15 flex items-center justify-center">
              <BadgeCheck size={28} className="text-[#00D285]" />
            </div>
            <div className="min-w-0">
              <div className="font-semibold text-slate-900 dark:text-white truncate">
                {user?.name || "Cliente GoProtege"}
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                {user?.document_type?.toUpperCase()}: {user ? formatCpfCnpj(user.document) : "—"}
              </div>
              <div className="mt-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#00D285]/10 text-[#00D285] text-xs font-semibold">
                <ShieldCheck size={12} /> Ativo
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={() => setShowTerms(true)}
          className="btn-press w-full bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 text-slate-700 dark:text-slate-200 font-semibold py-3.5 rounded-xl flex items-center justify-center gap-2 hover:bg-slate-50 dark:hover:bg-slate-800/40"
        >
          <FileText size={16} className="text-slate-500" /> Termos de Uso
        </button>

        <button
          data-testid="logout-button"
          onClick={logout}
          className="btn-press w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-red-600 dark:text-red-400 font-semibold py-3.5 rounded-xl flex items-center justify-center gap-2 hover:bg-red-50 dark:hover:bg-red-900/20"
        >
          <LogOut size={16} /> Sair
        </button>
      </main>

      <TermsModal 
        isOpen={showTerms} 
        onClose={() => setShowTerms(false)} 
        readOnly={true} 
      />

      <BottomNav />
    </div>
  );
}
